module.exports = __webpack_public_path__ + "static/media/mastercard.4d884409.svg";